"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreGlobalHeadersService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var Http_service_1 = require("./http/Http.service");
var BaseGlobalHeaders_service_1 = require("./BaseGlobalHeaders.service");
var CoreGlobalHeadersService = /** @class */ (function (_super) {
    __extends(CoreGlobalHeadersService, _super);
    function CoreGlobalHeadersService(httpService) {
        var _this = _super.call(this) || this;
        _this.httpService = httpService;
        _this.intercept = function (request, next) {
            if (request.options.ignoreGlobalHeaders) {
                return next.handle(request);
            }
            return next.handle(request.clone({
                headers: __assign(__assign({}, _this.getGlobalHeaders()), request.options.headers),
            }));
        };
        _this.httpService.addInterceptor({ intercept: _this.intercept });
        return _this;
    }
    CoreGlobalHeadersService.prototype.getGlobalHeaders = function () {
        var headers = {
            accept: 'application/json, text/plain, */*',
            'content-type': 'application/json;charset=UTF-8',
        };
        return headers;
    };
    CoreGlobalHeadersService.prototype.encodeHeader = function (headerValue) {
        return ('encoded:' +
            btoa(encodeURIComponent(headerValue).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
                return String.fromCharCode(('0x' + p1));
            })));
    };
    CoreGlobalHeadersService = __decorate([
        CommonService_decorator_1.CommonService('GlobalHeadersService', { alwaysInitialized: true }),
        __metadata("design:paramtypes", [Http_service_1.HttpService])
    ], CoreGlobalHeadersService);
    return CoreGlobalHeadersService;
}(BaseGlobalHeaders_service_1.BaseGlobalHeadersService));
exports.CoreGlobalHeadersService = CoreGlobalHeadersService;
//# sourceMappingURL=CoreGlobalHeaders.service.js.map